let apiUrl
const apiUrls = {
  production: 'https://nameless-earth-46490.herokuapp.com',
  development: 'http://localhost:4741'
}

if (window.location.hostname === 'localhost') {
  apiUrl = apiUrls.development
} else {
  apiUrl = apiUrls.production
}

export default apiUrl



// WEBPACK FOOTER //
// ./src/apiConfig.js